'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var moment = require('moment-timezone');
require('intl-tel-input/build/js/utils');
var urls = require('../../utilities/urls').default;
var libphonenumber = require('libphonenumber-js');
var polyglot = require('../../utilities/polyglot').default;
require('intl-tel-input/build/js/intlTelInput.min');

var FormView = require('../form').default;
var Preference = require('../../models/preference').default;
var PreferenceListView = require('./preference-list').default;
var PreferenceCollection = require('../../collections/preferences').default;

export default FormView.extend({

  className: 'form advanced-wait-list-form',
  template: require('./templates/advanced-form.hbs'),
  events: {
    'change .type': 'onChangeType',
    'click .add_preference': 'onAddPreference',
    'click .clear_preference': 'onRemovePreference',
    'click .advanced-toggle': 'onAdvancedToggle',
    'click .cancel, .fancy-modal-close-mobile': 'onClickCancel',
  },
  regions: {
    buttons: '.form-buttons',
  },
  ui: {
    location_id: '#location',
    service_id: '#service',
    first_name: '#modal-first-name',
    last_name: '#modal-last-name',
    email: '#modal-email',
    cell_phone: '#modal-cell-phone',
    request: '#advanced-details',
    staff_id: '#staff',
    certain_days: '.specific-day',
    certain_days_preferences: '.specific-day-preferences',
    advanced_preferences: '.advanced-advanced',
  },
  submit: {
    className: 'button full',
    text: polyglot.t('advanced_wait_list.join_waitlist'),
  },
  defaultErrorMessage: polyglot.t('wait_list.error'),

  initialize: function (options) {
    this.smsEnabled = options.smsEnabled;

    if (!this.model.isNew()) {
      var staffId = this.model.get('staff_id');
      this.model.set('staff_id', String(!window.SETTINGS.enable_builder && staffId ? staffId : 'null'));
      this.model.multiService = false;
      this.model.timezoneAbbr = this.model.getTimezoneAbbr();
      this.model.timezone = this.model.getTimezone();
      this.submit.text = polyglot.t('advanced_wait_list.save');
    }

    this.staff = options.staff;
    this.random = new Backbone.Model({
      id: 'null',
      full_name: polyglot.t('advanced_wait_list.random'),
    });
    this.model.set('booked_through', window.CONSTANTS.ORIGIN_CLIENT_VIEW);
    this.preferencesView = new PreferenceListView({
      collection: this.model.get('preferences') || new PreferenceCollection(),
      service_duration: this.getServiceDuration(),
    });

    this.preferenceType = Preference.TYPES.NEXT_AVAILABLE;
    var preferences = this.model.get('preferences');
    if (preferences && preferences.length) {
      this.preferenceType = preferences.first().get('type');
    }

    this.listenTo(this, 'submit', this.onValidSubmit);
    this.listenTo(Radio.channel('windows'), 'close', this.onCloseModal);
  },

  serializeData: function () {
    var json = this.model.toJSON();
    json.showMobilePhone = this.model.showMobilePhone();
    json.isMobilePhoneRequired = this.model.isMobilePhoneRequired();

    if (json.location) {
      json.locationDisplay = this.getLocationDisplay(json.location);
    }

    json.staffPickerDisabled = this.model.isStaffPickerHidden();

    json.staff = _.map(this.staff.models, function (person) {
      return person.toJSON();
    });
    json.staff.unshift(this.random.toJSON());

    json.days = Preference.DAYS;
    json.nextAvailable = this.preferenceType === Preference.TYPES.NEXT_AVAILABLE;
    json.multiService = this.model.multiService;

    var timezone = this.model.timezone;
    timezone = timezone.replace(/_/g, ' ');
    json.tz = `${timezone} (${this.model.timezoneAbbr})`;

    json.isEditing = !this.model.isNew();

    var cellPhone = json.client ? json.client.cell_phone : '';
    json.formattedCellPhone = cellPhone ? libphonenumber.formatNumber(cellPhone, 'International') : '';

    json.title = this.model.isNew() ? polyglot.t('wait_list.title') : polyglot.t('wait_list.edit_title');

    json.nextAvailable = this.preferenceType === Preference.TYPES.NEXT_AVAILABLE;

    return json;
  },

  getLocationDisplay: function (location) {
    var name = location.name;

    return location.virtual ? name : `${name} ${location.formatted_address}`;
  },
  onRender: function () {
    FormView.prototype.onRender.call(this, arguments);

    if (this.model.has('location_id')) {
      this.ui.location_id.val(this.model.get('location_id'));
    }

    if (this.model.has('service_id')) {
      this.ui.service_id.val(this.model.get('service_id'));
    }

    this.ui.staff_id.val(this.model.get('staff_id'));

    this.ui.certain_days_preferences.prepend(this.preferencesView.render().el);
    if (this.preferenceType === Preference.TYPES.CERTAIN_DAYS) {
      this.ui.certain_days.show();
    } else {
      this.ui.certain_days.hide();
    }
    this.ui.advanced_preferences.hide();
    this.renderIntlTelInputs();
    this.addFancyClass();
  },

  addPreferenceId: function (index) {
    this.ui = {
      ...this.ui,
      [`preference-${index}`]: $(`#preference-${index}`),
    };
  },

  getServiceDuration: function () {
    var service = this.model.get('service');

    return service.duration + service.buffer_post;
  },

  onChangeType: function (evt) {
    evt.preventDefault();
    var target = $(evt.target);

    if (target.val() === Preference.TYPES.CERTAIN_DAYS.toString()) {
      this.preferenceType = Preference.TYPES.CERTAIN_DAYS;
      this.ui.certain_days.show();
    } else {
      this.preferenceType = Preference.TYPES.NEXT_AVAILABLE;
      this.ui.certain_days.hide();
    }
  },

  onAddPreference: function (evt) {
    evt.preventDefault();
    this.preferencesView.addPreference();
  },

  onRemovePreference: function (evt) {
    evt.preventDefault();
  },

  onAdvancedToggle: function (evt) {
    evt.preventDefault();
    this.toggleChevron();
    this.ui.advanced_preferences.toggle();
    $('#staff').focus();
  },

  onClickCancel: function (evt) {
    evt.preventDefault();
    this.onCloseModal();
  },

  toggleChevron: function () {
    var icon = $('.advanced-icon');
    var header = $('label.advanced-toggle');

    if (icon.hasClass('fa-chevron-down')) {
      icon.removeClass('fa-chevron-down');
      icon.addClass('fa-chevron-up');
      header.addClass('expanded');
    } else {
      icon.removeClass('fa-chevron-up');
      icon.addClass('fa-chevron-down');
      header.removeClass('expanded');
    }
  },

  addFancyClass: function () {
    $('.modal').addClass('fancy-modal');
    $('.modal-body').addClass('fancy-modal-body');
    $('.modal-close').addClass('fancy-modal-close');
  },

  removeFancyClass: function () {
    $('.modal').removeClass('fancy-modal');
    $('.modal-body').removeClass('fancy-modal-body');
    $('.modal-close').removeClass('fancy-modal-close');
  },

  renderIntlTelInputs: function () {
    this.ui.cell_phone.intlTelInput({
      nationalMode: true,
      initialCountry: 'auto',
      geoIpLookup: function (callback) {
        $.get('https://ipinfo.io', function () {}, 'jsonp').always(function (resp) {
          var countryCode = (resp && resp.country) ? resp.country : 'US';
          callback(countryCode);
        });
      },
    });
  },

  onCloseModal: function () {
    this.removeFancyClass();
    Radio.channel('modal').trigger('hide');
    Radio.channel('windows').trigger('focusWaitlist');
  },

  onValidSubmit: function () {
    if (!this.model.isNew() || (!this.model.isMobilePhoneRequired() && !$(this.ui.cell_phone).val())) {
      this.model.unset('cell_phone');
    }

    var timezone = this.model.timezone;
    this.model.get('preferences').each(preference => preference.formatTime(timezone));
    this.model.set('timezone', timezone);

    this.model.save({
      _token: $('meta[name="csrf-token"]').attr('content'),
    }, {
      success: _.bind(this.onSaveSuccess, this),
      error: _.bind(this.onSaveError, this),
      validate: false,
    });
  },

  onSaveSuccess: function (model, response, options) {
    this.removeFancyClass();
    this.enableSubmit();
    Radio.channel('modal').trigger('hide');

    var request = response.data.request;
    var { origin, pathname, search } = Backbone.history.location;
    search = urls.addParams({
      request_id: request.id,
      cid: request.client_id,
    });
    var href = `${origin}${pathname}${search}#${polyglot.t('pages.waitlist_confirmation.slug')}`;
    if (Backbone.history.location.href === href) {
      // if editing the request, simply update the model on the confirmation page
      Radio.channel('waitlist-confirmation').trigger(
        'renderUpdatedRequest',
        response.data.request,
        polyglot.t('pages.waitlist_confirmation.request_updated'),
      );
    } else {
      window.localStorage.setItem('waitlistConfirmationMessage', polyglot.t('pages.waitlist_confirmation.request_added'));
      Backbone.history.location.href = href;
    }
  },

  onSaveError: function (model, response, options) {
    this.enableSubmit();
    if (response.responseJSON.data.d) {
      Radio.channel('modal').trigger('hide');
      Radio.channel('waitlist-confirmation')
        .trigger('renderUpdatedRequest', null);
    } else {
      Radio.channel('toast').trigger('show', {
        message: this.getErrorMessage(response),
        iconColor: 'error',
      });
    }
  },

  getErrorMessage: function (response) {
    if (!_.isEmpty(response.responseJSON.data)) {
      return _.flatten(_.values(response.responseJSON.data)).join('<br>');
    }

    if (response.responseJSON.message) {
      return response.responseJSON.message;
    }

    return this.defaultErrorMessage;
  },

  setPreferences: function () {
    if (this.preferenceType === Preference.TYPES.NEXT_AVAILABLE) {
      // when editing the preferences, and the preference is already set to NEXT_AVAILABLE,
      // don't reset it
      var prevPreferences = this.model.get('preferences');
      if (prevPreferences && prevPreferences.first().get('type') === Preference.TYPES.NEXT_AVAILABLE) {
        return prevPreferences;
      }

      return new PreferenceCollection(new Preference({
        type: Preference.TYPES.NEXT_AVAILABLE,
        start_date: moment().tz(this.model.timezone).format('YYYY-MM-DD HH:mm:ss'),
      }));
    }

    var self = this;
    this.preferencesView.prefs.forEach((pref) => {
      self.addPreferenceId(pref.index);
    });

    return this.preferencesView.getPreferenceCollection();
  },

  updateModel: function () {
    var staffId = this.model.isStaffPickerHidden() ?
      this.model.get('staff_id') : this.ui.staff_id.val();

    this.model.set('staff_id', staffId > 0 ? staffId : null);
    this.model.set('first_name', this.ui.first_name.val());
    this.model.set('last_name', this.ui.last_name.val());
    this.model.set('email', this.ui.email.val());
    this.model.set('cell_phone', this.ui.cell_phone.intlTelInput('getNumber'));
    this.model.set('request', this.ui.request.val());
    this.model.set('lang', $('html').attr('lang'));
    this.model.set('preferences', this.setPreferences());
  },
});
